import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Download } from 'lucide-react';
import Loading from './Loading';
import '../styles/PDFViewer.css';
import { beginDownloadNotification, markDownloadNotificationStarted, dismissDownloadNotification } from '../utils/downloadNotifications';

export const PDFViewer = () => {
  const { fileId } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [fileName, setFileName] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFileDetails = async () => {
      if (!fileId) {
        setError("No file specified");
        setLoading(false);
        return;
      }

      try {
        const decodedFileId = decodeURIComponent(fileId);
        
        setFileUrl(`https://api.casedb.co/pdf-proxy.php?fileKey=${encodeURIComponent(decodedFileId)}`);
        
        const fileName = decodedFileId.split('/').pop() || 'document.pdf';
        setFileName(fileName);
        
        setLoading(false);
      } catch (err) {
        console.error("Error loading PDF:", err);
        setError(err.message || 'An error occurred loading the file');
        setLoading(false);
      }
    };

    fetchFileDetails();
  }, [fileId]);

  const handleDownload = async () => {
    const notificationId = beginDownloadNotification(fileName || 'PDF');
    try {
      const downloadUrl = `https://api.casedb.co/pdf-proxy.php?fileKey=${encodeURIComponent(fileId)}&download=true`;
      
      window.open(downloadUrl, '_blank');
      markDownloadNotificationStarted(notificationId);
    } catch (err) {
      dismissDownloadNotification(notificationId);
      console.error('Download failed:', err);
      alert('Download failed: ' + err.message);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  if (loading) {
    return <div className="pdf-viewer-page"><Loading /></div>;
  }

  if (error) {
    return (
      <div className="page-container full pdf-viewer-page">
        <div className="pdf-viewer-header">
          <button className="action" onClick={handleBack}><ArrowLeft size={16} /> Back</button>
          <h2>Error</h2>
        </div>
        <div className="pdf-viewer-error">
          <p>{error}</p>
          <button className="action" onClick={handleBack}>Return to Library</button>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container full pdf-viewer-page">
      <div className="pdf-viewer-header">
        <button className="action" onClick={() => window.close()}><ArrowLeft size={16} /> Back to Library</button>
        <h2>{fileName}</h2>
        <button className="action" onClick={handleDownload}><Download size={16} /> Download</button>
      </div>
      
      <div className="pdf-viewer-container fullscreen">
        <iframe
          src={fileUrl}
          type="application/pdf"
          width="100%"
          height="100%"
          className="pdf-viewer"
          title={fileName}
        >
          <p>
            Your browser doesn't support embedded PDFs.
            <a href={fileUrl + '&download=true'} download={fileName}>Download the PDF</a> instead.
          </p>
        </iframe>
      </div>
    </div>
  );
};
